import { Injectable } from '@angular/core';
import { ConfigService } from '../provider/config.service';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class DataResolverService implements Resolve<any>{

    constructor(
        private configService: ConfigService
    ) { }
    resolve(route: ActivatedRouteSnapshot) {
        const id = route.paramMap.get('id');
        return this.configService.getQueryData(id);
    }
}
